import axios from 'axios'

const API_BASE = process.env.REACT_APP_NEXTERA_API

export interface IZone {
  id: number
  name: string
  description: string | null
  point_ids: number[]
  created_at: string
  updated_at: string
}

export const fetchZones = async (
  projectId: string,
  floorId: string,
): Promise<IZone[]> => {
  try {
    const res = await axios.get(
      `${API_BASE}/project/${projectId}/floor/${floorId}/zones`,
    )
    return res.data.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('Error fetching zones:', err)
    throw err
  }
}

export const createZone = async (
  projectId: string,
  floorId: string,
  name: string,
): Promise<IZone> => {
  try {
    const res = await axios.post(
      `${API_BASE}/project/${projectId}/floor/${floorId}/zone`,
      {
        name,
        description: null,
      },
    )
    return res.data.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('Error creating zone:', err)
    throw err
  }
}

export const deleteZone = async (
  projectId: string,
  floorId: string,
  zoneId: number,
): Promise<void> => {
  try {
    await axios.delete(
      `${API_BASE}/project/${projectId}/floor/${floorId}/zone/${zoneId}`,
    )
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('Error deleting zone:', err)
    throw err
  }
}

export const addPointToZone = async (
  projectId: string,
  floorId: string,
  zoneId: number,
  pointId: number,
): Promise<IZone> => {
  try {
    const res = await axios.post(
      `${API_BASE}/project/${projectId}/floor/${floorId}/zone/${zoneId}/add-point`,
      { point_id: pointId },
    )
    return res.data.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('Error adding point to zone:', err)
    throw err
  }
}

export const removePointFromZone = async (
  projectId: string,
  floorId: string,
  zoneId: number,
  pointId: number,
): Promise<void> => {
  try {
    await axios.delete(
      `${API_BASE}/project/${projectId}/floor/${floorId}/zone/${zoneId}/remove-point/${pointId}`,
    )
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('Error removing point from zone:', err)
    throw err
  }
}
